// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"Va","hidden":"Wa","preventTransition":"Xa","divBgImg":"Ya","loaded":"Za"};